import { TODOS } from "../config";
import { get, post } from "./apiHelper";

export const fetchTodos = () => get(TODOS, { noCache: true });

export const fetchTodoSummary = () =>
  get(`${TODOS}/summary`, { noCache: true });

export const createTodo = (payload) => post(`${TODOS}/create`, payload);

export const updateTodo = (id, payload) =>
  post(`${TODOS}/update/${id}`, payload);

export const deleteTodo = (id) => post(`${TODOS}/delete/${id}`);
